// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.Icon = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _Icon = require('./Icon.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Icon = function Icon(props) {
  var children = props.children;
  return _react.default.createElement(_Icon.StyledIcon, props, children);
};
/**
 * Definition of default values for component props
 */

exports.Icon = Icon;
Icon.defaultProps = {
  width: undefined,
  height: undefined,
  color: undefined,
  disabled: false,
  className: undefined,
  id: undefined
};
/**
 * Definition of types for component props
 */

Icon.propTypes = {
  /** Collection of items in the list. Must be a collection of ListItems */
  children: _propTypes.default.object.isRequired,

  /** The CSS width property */
  width: _propTypes.default.string,

  /** The CSS height property */
  height: _propTypes.default.string,

  /** The icon color property */
  color: _propTypes.default.string,

  /** Whether it is disbled or not */
  disabled: _propTypes.default.bool,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string
};


